export const leadsStatusData = [
    {
        id: 1,
        name: "Archie Tones",
        img: "/images/avatar/1.png",
        date: "15 June, 2023",
        status: "Deal Won",
        value: "15.56K",
        badgeColor: "success"
    },
    {
        id: 2,
        name: "Holmes Cherry",
        img: "/images/avatar/2.png",
        date: "18 June, 2023",
        status: "Intro Call",
        value: "10.24K",
        badgeColor: "warning"
    },
    {
        id: 3,
        name: "Kenneth Hune",
        img: "/images/avatar/3.png",
        date: "20 June, 2023",
        status: "Stuck",
        value: "12.47K",
        badgeColor: "primary"
    },
    {
        id: 4,
        name: "Malanie Hanvey",
        img: "/images/avatar/4.png",
        date: "22 June, 2023",
        status: "Cancelled",
        value: "10.88K",
        badgeColor: "danger"
    },
    {
        id: 5,
        name: "Valentine Maton",
        img: "/images/avatar/5.png",
        date: "25 June, 2023",
        status: "Progress",
        value: "13.85K",
        badgeColor: "primary"
    },

]